var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"report-tag-box"},[_c('div',{staticClass:"dot"}),_c('img',{attrs:{"src":require("@/assets/image/btcinfo/cow.png")}}),_c('span',[_vm._v(_vm._s(_vm.getMonth(_vm.title)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }